export const planTypeForValue = value => {
  let type
  switch (value) {
    case 100:
      type = 'FREE'
      break
    case 200:
      type = 'PRO'
      break
    case 300:
      type = 'TEAM'
      break
    default:
      type = 'FREE'
  }
  return type
}

export const planTypes = {
  free: 100,
  pro: 200,
  team: 300,
}



// WEBPACK FOOTER //
// ./src/utils/planType.js